import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import FAQ from '../faq/FAQ'
import {doBrowserCheck, getServiceCenterInfo} from '../../lib/emmiApi'
import {LOG_EVENTS} from 'wipi-common/src/lib/logging/events'
import ServiceCenterBanner from './ServiceCenterBanner'
import ContinueInBrowser from './ContinueInBrowser'
import BackToMethodSelectionButton from '../misc/BackToMethodSelectionButton'
import MethodTitle from '../misc/Method-title/MethodTitle'
import ShortCaseInfo from '../misc/ShortCaseInfo'
import {getI18nTextWithContext, getI18nTextWithParentKey} from "wipi-common/src/lib/i18n"
import LOG from "wipi-common/src/lib/logging/logger"
import {useI18nContext} from "../i18n/I18nContext"
import FaceDetectionHint from "./FaceDetectionHint";
import InstallAppBanner from "../misc/InstallAppBanner";
import videoIlluDark from '../../assets/illustrations/video-description-dark.svg'
import videoIlluLight from '../../assets/illustrations/video-description-light.svg'

export default function StartVideo({caseInfo, browserInfo, setBrowserInfo}) {
    const context = useI18nContext()
    const [serviceCenterInfo, setServiceCenterInfo] = useState({})

    let availability = caseInfo.modules.identMethodSelection.methodChoice.find(method => {
        return method.method === 'video'
    }).footer;

    useEffect(() => {
        LOG.logInfo(LOG_EVENTS.IH_START_VIDEO)
    }, [context])

    useEffect(() => {
        if (!browserInfo.checkedVideo) {
            doBrowserCheck('video', caseInfo.caseId)
                .catch(() => ({ isBrowserSupported: false, isMobileDevice: browserInfo.isMobileDevice }))
                .then(({isBrowserSupported, isMobileDevice}) => {
                    const mergedBrowserInfo = Object.assign({}, browserInfo, {
                        isVideoSupported: isBrowserSupported,
                        checkedVideo: true,
                        isMobileDevice
                    })
                    setBrowserInfo(mergedBrowserInfo)
                })
        }
    }, [setBrowserInfo, caseInfo.caseId, browserInfo, browserInfo.checkedVideo])

    useEffect(() => {
        getServiceCenterInfo(caseInfo.callcenterCategory)
            .then(setServiceCenterInfo)
            .catch()
    }, [caseInfo.callcenterCategory,context])

    return <>
        <div className="headless">
            <div className="col-xl-6 col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2">
                <div className="row">
                    <MethodTitle
                        heading={getI18nTextWithContext(context, 'startVideo.heading')}
                        subHeading={getI18nTextWithContext(context, 'methodSelection.video.subHeading')}
                        info={getI18nTextWithContext(context, 'startVideo.info')}
                        testId="hkmewo45a8i9"/>
                </div>
                <InstallAppBanner
                    caseId={caseInfo.caseId}
                    isMobileDevice={browserInfo.isMobileDevice}
                    availability={availability}
                    illustrationDark={videoIlluDark}
                    illustrationLight={videoIlluLight}/>
                <FaceDetectionHint
                    caseInfo={caseInfo}/>
                <ServiceCenterBanner
                    info={serviceCenterInfo}/>
                <ContinueInBrowser
                    serviceCenterInBusiness={serviceCenterInfo.isInBusinessTime}
                    caseInfo={caseInfo}
                    isVideoSupported={browserInfo.isVideoSupported}/>
                <BackToMethodSelectionButton caseInfo={caseInfo} isMobileDevice={browserInfo.isMobileDevice}/>
            </div>
            <ShortCaseInfo caseId={caseInfo.caseId} bcName={caseInfo.principalDisplayName}/>
        </div>
        <FAQ faq={getI18nTextWithParentKey(context, 'startVideo.faq')}/>
    </>
}

StartVideo.propTypes = {
    caseInfo: PropTypes.shape({
        caseId: PropTypes.string.isRequired,
        principalDisplayName: PropTypes.string.isRequired,
        callcenterCategory: PropTypes.string.isRequired,
        modules: PropTypes.shape({
            identMethodSelection: PropTypes.shape({
                methodChoice: PropTypes.arrayOf(
                    PropTypes.shape({
                        method: PropTypes.string.isRequired,
                        footer: PropTypes.string
                    })
                ).isRequired
            }).isRequired
        }).isRequired
    }).isRequired,
    browserInfo: PropTypes.shape({
        isMobileDevice: PropTypes.bool.isRequired,
        checkedVideo: PropTypes.bool.isRequired,
        isVideoSupported: PropTypes.bool
    }).isRequired,
    setBrowserInfo: PropTypes.func.isRequired
}